import cn from 'clsx'
import {format} from 'date-fns'

import './CalendarDate.scss'

interface CalendarDateProps {
  date: Date
  error?: boolean
}

export default function CalendarDate({date, error}: CalendarDateProps) {
  return (
    <div className={cn('CalendarDate', error && 'CalendarDate_error')}>
      <p className="CalendarDate-Label">{format(date, 'MMM')}</p>
      <p className="CalendarDate-Value">{format(date, 'd')}</p>
      <p className="CalendarDate-Label">{format(date, 'E')}</p>
    </div>
  )
}
